define( [ 'jquery.validate' ], function run( $ ) {
	'use strict';

	/*
	 * Note: If you are looking to set defaults for any of the following and you
	 * want them to take effect in Unobtrusive then you will need to set those in
	 * the `jquery.validate.unobtrusive.wrapper.js` file as Unobtrusive sets
	 * these internally.
	 *
	 * errorClass, errorElement, errorPlacement, invalidHandler, success
	 *
	 * Setting those here will only take effect if a project uses Validate directly
	 */

	$.validator.setDefaults({
		// Do not validate elements with these selectors
		ignore : '.no-validate, [hidden="hidden"], :hidden',

		/*
		 * As of version 1.14.0 jquery validate stops trimming white spaces from
		 * the value, which means a single space can pass a required check.
		 * Adding `normalizer` reinstates this globally
		 */
		normalizer : function normalizer( value ) {
			return $.trim( value );
		},

		// Mirror unobtrusive class for ease of styling
		errorClass : 'input-validation-error',

		errorElement : 'span',

		errorPlacement : function errorPlacement( error, $element ) {
			var $rowContent = $element.closest( '.m-form-row__content' );
			var $message = $rowContent.find( '.m-form-row__error-message' );
			$message.empty().append( error );
		},

		showErrors : function showErrors() {
			this.defaultShowErrors();
		},

		highlight : function highlight( element ) {
			$( element )
				.closest( '.m-form-row' )
				.addClass( 'is-error' );
		},

		unhighlight : function unhighlight( element ) {
			$( element )
				.closest( '.m-form-row' )
				.removeClass( 'is-error' );
		},
	});

	return $;
});
